import { render, staticRenderFns } from "./direct-children-warning.vue?vue&type=template&id=666e174e&scoped=true"
import script from "./direct-children-warning.vue?vue&type=script&lang=js"
export * from "./direct-children-warning.vue?vue&type=script&lang=js"
import style0 from "./direct-children-warning.vue?vue&type=style&index=0&id=666e174e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "666e174e",
  null
  
)

export default component.exports